<ng5-slider [(value)]="value" [(highValue)]="highValue" [options]="options" (userChangeEnd)="updateInput()"></ng5-slider>


// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-3/triple-percentage-slider/triple-percentage-slider.component.html